import * as service from './service'
export default {
  namespace: 'shansongValuev2Sign',
  state: {
    demoData: {}
  },
  effects: {
    * dcourierControlSign ({ payload }, { call, put }) {
      const res = yield call(service.dcourierControlSign, payload)
      return res
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
